'use client';

import { Tabs } from '@zillow/constellation-10';
import { type ComponentProps, useLayoutEffect, useRef } from 'react';

type Props = Omit<ComponentProps<typeof Tabs.Root>, 'aria-label' | 'role'> & {
  ariaLabel: string;
};

export const AccessibleTabsRoot = ({ ariaLabel, children, ...props }: Props) => {
  const rootRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    // Floating UI puts aria-orientation on this generated parent, so it must own the tablist role.
    const composite = rootRef.current?.parentElement;
    composite?.setAttribute('role', 'tablist');
    composite?.setAttribute('aria-label', ariaLabel);
  }, [ariaLabel]);

  return (
    <Tabs.Root ref={rootRef} role="presentation" {...props}>
      {children}
    </Tabs.Root>
  );
};
